import dark from "./dark";
import light from "./light";
import highContrast from "./highContrast";

export default { dark, light, highContrast };
